export default function SitesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('sites');
    $translatePartialLoaderProvider.addPart('certifications');
}

SitesConfiguration.$inject = ['$translatePartialLoaderProvider'];
